<template>
    <div
        class="h-full p-px rounded-2xl hover:bg-[linear-gradient(135.39deg,#BDB1FF_7.01%,#6952ED_93.21%)] dark:hover:bg-[linear-gradient(135.39deg,#3840B5_7.01%,#0B0B26_93.21%)]"
        :class="active
            ? 'bg-[linear-gradient(135.39deg,#BDB1FF_7.01%,#6952ED_93.21%)] dark:bg-[linear-gradient(135.39deg,#3840B5_7.01%,#0B0B26_93.21%)]'
            : 'bg-transparent'">
        <div
            class="h-full rounded-[15px] px-[28px] py-[18px] md:px-4 md:py-4 lg:px-[28px] lg:py-[18px] text-left bg-[linear-gradient(196.53deg,#FFFFFF_61.83%,#F3F0FF_88.29%)] dark:bg-[linear-gradient(196.53deg,#040717_61.83%,#03031F_88.29%)]">
            <div class="flex items-center gap-4">
                <div class="size-[30px] md:size-[26px] lg:size-[30px] flex-shrink-0 flex items-center justify-center"
                    aria-hidden="true">
                    <component :is="tab.icon" class="size-[26px] md:size-[22px] lg:size-[26px] text-[#1E1B4B] dark:text-white" />
                </div>
                <div class="min-w-0">
                    <h3 class="font-anvtgrade-book font-normal text-[18.19px] md:text-[17px] md:leading-snug lg:text-[18.19px] max-md:leading-snug leading-none text-[#1E1B4B] dark:text-white">
                        {{ tab.title }}</h3>
                    <p
                        class="font-anvtgrade-book mt-[6px] text-[13.64px] md:text-[13px] md:leading-snug lg:text-[13.64px] max-md:leading-snug leading-none tracking-[2%] text-[#6D28D9] dark:text-[#7782FF]">
                        {{ tab.text }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { Component } from "vue";

interface ApplicationTab {
    title: string;
    text: string;
    icon: Component;
}

withDefaults(defineProps<{
    tab: ApplicationTab;
    active?: boolean;
}>(), {
    active: false,
});
</script>
